import { Label } from "@mui/icons-material"
import { Divider, Grid, Typography } from "@mui/material/node"



export const TextDivider = (props) => {
    return (
        <Grid container spacing={0.2} alignItems="center">
            <Grid item xs={5} md={5}>
                <Divider />
            </Grid>
            <Grid item xs={2} md={2}>
                <Typography 
                    mx={2}
                    color="gray.400"
                    textTransform="lowercase"
                    fontStyle="italic"
                    fontWeight="bold"
                >
                    {props.text}
                </Typography>
            </Grid>
            <Grid item xs={5} md={5}>
                <Divider />
            </Grid>
        </Grid>
    )
}